import { useState } from 'react'
import styles from './FrozenMemberList.module.css'

const COLLAPSE_THRESHOLD = 8

interface Props {
  teamMemberLogins: Record<string, string[]>
  label?: string
}

export function FrozenMemberList({ teamMemberLogins, label: _label }: Props) {
  const [expanded, setExpanded] = useState(false)

  const allMembers = [...new Set(
    Object.values(teamMemberLogins).flat()
  )]

  if (allMembers.length === 0) return null

  const collapsed = !expanded && allMembers.length > COLLAPSE_THRESHOLD
  const visible = collapsed ? allMembers.slice(0, COLLAPSE_THRESHOLD) : allMembers
  const hidden = allMembers.length - COLLAPSE_THRESHOLD

  return (
    <div className={styles.wrap}>
      <div className={styles.hint}>You are directly watching these authors via your author team subscriptions — up to 1 hour stale, reconciled hourly with GitHub as members join or leave.</div>
      <div className={styles.chips}>
        {visible.map(login => (
          <span key={login} className={styles.chip}>{login}</span>
        ))}
        {collapsed && (
          <button className={styles.expandBtn} onClick={() => setExpanded(true)}>
            +{hidden} more
          </button>
        )}
        {expanded && allMembers.length > COLLAPSE_THRESHOLD && (
          <button className={styles.expandBtn} onClick={() => setExpanded(false)}>
            Show less
          </button>
        )}
      </div>
    </div>
  )
}
